import React from "react"
import { getUserCreds, socket } from "../utils/utils"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { setModalData } from "../store/globalSlice"
import ModalButton from "@/Components/ModalButton"
import GameTimer from "@/Components/GameTimer"
import Money from "@/Components/Money"
import cardsIcon from "@/images/icons/cards.png"
import Modal from "@/Components/Modal"
import { useTimerTickSound } from "@/Hooks/useTimerTickSound"
import { useGameTimings } from "@/Hooks/useGameTimings"

const DecisionHubModal = () => {
  const dispatch = useAppDispatch()
  const myGame = useAppSelector((state) => state.global.myGame)
  const { cardDecisionTime } = useGameTimings()
  // Only the player whose turn it is sees (and is timed on) this choice.
  useTimerTickSound(
    getUserCreds().email === myGame?.situation?.turn,
    "cardDecisionTimeLeft"
  )

  const handleGetMoney = () => {
    socket.emit("game.decision-hub-response", {
      roomid: myGame?.id || "",
      choice: "money",
    })
    dispatch(setModalData({ decisionHub: { visible: false } }))
  }

  const handleGetCards = () => {
    socket.emit("game.decision-hub-response", {
      roomid: myGame?.id || "",
      choice: "cards",
    })
    dispatch(setModalData({ decisionHub: { visible: false } }))
  }
  const cardsToGet = myGame?.settings.mapId === "1" ? 2 : 3
  const cardsToGetText = myGame?.settings.mapId === "1" ? "2" : "3"
  if (getUserCreds().email !== myGame?.situation?.turn) return null

  return (
    <Modal
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[60] w-[90%] max-w-2xl"
      icon={<i className="fa-solid fa-gift text-white text-2xl"></i>}
      title="Choose Your Reward"
      subtitle="Take the cash, or draw cards"
      contentClassName="flex flex-col items-center space-y-8 px-8 pb-8 text-white"
    >
      {/* Timer */}
      <div className="w-full flex justify-center">
        <GameTimer
          timerKey="cardDecisionTimeLeft"
          totalTime={cardDecisionTime}
          size="md"
          showLabel={true}
          labelText="Decision Time"
        />
      </div>

      {/* Options side by side */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 gap-y-10 w-full items-end">
        {/* Money Option */}
        <div className="self-end flex flex-col items-center space-y-6 rounded-xl border border-gray-700/60 bg-white/5 p-6 hover:bg-white/10 transition">
          <div className="font-poppins flex flex-col items-center justify-center gap-3">
            <Money
              money={250}
              className="gap-2 text-4xl md:text-5xl inline-flex"
              iconClass="h-10"
            />
          </div>
          <ModalButton
            color="green"
            onClick={handleGetMoney}
            className="w-full max-w-md mt-2"
          >
            <div className="flex items-center justify-center gap-2">
              <i className="fa-money-bill fa-solid text-white fa-lg"></i>
              <span className="text-white font-medium font-poppins text-lg">
                Get Money
              </span>
            </div>
          </ModalButton>
        </div>

        {/* Cards Option */}
        <div className="self-end flex flex-col items-center space-y-6 rounded-xl border border-gray-700/60 bg-white/5 p-6 hover:bg-white/10 transition">
          <div className="font-poppins flex  items-center justify-center gap-3">
            <span className="text-3xl md:text-4xl font-bold">
              {cardsToGetText} Cards
            </span>
            <img src={cardsIcon} alt="Cards" className="h-8 md:h-10 w-auto" />
          </div>
          <ModalButton
            color="blue"
            onClick={handleGetCards}
            className="w-full max-w-md mt-2"
          >
            <div className="flex items-center justify-center gap-2">
              <img src={cardsIcon} alt="Cards" className="h-6 w-auto" />
              <span className="text-white font-medium font-poppins text-lg">
                Get Cards
              </span>
            </div>
          </ModalButton>
        </div>
      </div>
    </Modal>
  )
}

export default DecisionHubModal
